import {allowsBiteGa4} from './bite-ga4-policy';

const KEY='bite_ga4_acquisition_v1',TTL=30*60*1000;
const domains:Record<string,string[]>={bullstory:['bullstory.io'],instagram:['instagram.com'],facebook:['facebook.com','fb.com'],threads:['threads.net','threads.com'],telegram:['t.me','telegram.org'],google:['google.com','google.co.kr'],naver:['naver.com']};
const clean=(value:string|null)=>value&&value.length<=100&&/^[\p{L}\p{N} _.-]+$/u.test(value)&&!/[\d]{9,}/.test(value)?value:'';
type Acquisition=Record<string,string>;
function safeSaved(input:unknown):Acquisition|null{
  if(!input||typeof input!=='object')return null;
  const values=input as Acquisition,result:Acquisition={};
  for(const field of ['campaign_source','campaign_medium','campaign_name','campaign_content','campaign_term']){
    const value=values[field];
    if(value==='(direct)'||value==='(none)'||value==='(not set)')result[field]=value;
    else if(typeof value==='string'&&clean(value))result[field]=value;
  }
  if(Object.values(domains).some(list=>values.page_referrer===`https://${list[0]}/`))result.page_referrer=values.page_referrer;
  return result.campaign_source&&result.campaign_medium?result:null;
}
function entry():Acquisition|null{
  const query=new URLSearchParams(location.search),source=clean(query.get('utm_source'));
  if(source){
    const result:Acquisition={campaign_source:source,campaign_medium:clean(query.get('utm_medium'))||'(not set)'};
    for(const [utm,field] of [['utm_campaign','campaign_name'],['utm_content','campaign_content'],['utm_term','campaign_term']]){
      const value=clean(query.get(utm));if(value)result[field]=value;
    }
    return result;
  }
  let host='';try{host=new URL(document.referrer).hostname.toLowerCase();}catch{return null;}
  if(host===location.hostname||/^(www\.)?bite\.cx$/.test(host)||['accounts.google.com','appleid.apple.com','checkout.stripe.com','billing.stripe.com','ticker.bullstory.io'].includes(host))return null;
  const known=Object.entries(domains).find(([,list])=>list.some(domain=>host===domain||host.endsWith('.'+domain)));
  // Only approved public origins leave the browser. Never forward private referrer paths or queries.
  return known?{campaign_source:known[0],campaign_medium:['google','naver'].includes(known[0])?'organic':'referral',page_referrer:`https://${known[1][0]}/`}:{campaign_source:'other',campaign_medium:'referral'};
}
let initial=typeof window==='undefined'?null:entry(),documentEntry=true;
let current:{at:number;values:Acquisition}|null=null;
export function biteGa4Attribution():Acquisition{
  if(!allowsBiteGa4())return {};
  if(documentEntry){
    documentEntry=false;
    try{const saved=JSON.parse(sessionStorage.getItem(KEY)||'null'),values=safeSaved(saved?.values);if(saved?.at&&Date.now()-saved.at<TTL&&values)current={at:saved.at,values};}catch{/* storage unavailable */}
    if(initial)current={at:Date.now(),values:initial};
    initial=null;
  }
  if(!current||Date.now()-current.at>=TTL)current={at:Date.now(),values:{campaign_source:'(direct)',campaign_medium:'(none)'}};
  current.at=Date.now();
  try{sessionStorage.setItem(KEY,JSON.stringify(current));}catch{/* collection must not block navigation */}
  return {...current.values};
}
export function clearBiteGa4Attribution(){
  current=null;initial=null;documentEntry=false;
  try{sessionStorage.removeItem(KEY);}catch{/* storage unavailable */}
}
